// extracted by mini-css-extract-plugin
export var fullGrid = "_3g-3";
export var pdpPreviewContainer = "_3g-1";
export var previewContainer = "_3g-0";
export var togglePreviewContainer = "_3g-2";